export default {
  user: undefined,
  adminDocs: undefined,
  services: [],
  usageDatas: undefined,
  adminDocid: '',
  petalCounter: undefined,
  dematStatus: undefined,
};
